namespace TabAurous.Sales {
    export namespace SalesReturnMasterService {
        export const baseUrl = 'Sales/SalesReturnMaster';

        export declare function Create(request: Serenity.SaveRequest<SalesReturnMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SalesReturnMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SalesReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PostedTransIdList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function APIImportPurchaseReturns(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/SalesReturnMaster/Create",
            Update = "Sales/SalesReturnMaster/Update",
            Delete = "Sales/SalesReturnMaster/Delete",
            Retrieve = "Sales/SalesReturnMaster/Retrieve",
            List = "Sales/SalesReturnMaster/List",
            PartyList = "Sales/SalesReturnMaster/PartyList",
            PostedTransIdList = "Sales/SalesReturnMaster/PostedTransIdList",
            APIImportPurchaseReturns = "Sales/SalesReturnMaster/APIImportPurchaseReturns"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'PartyList', 
            'PostedTransIdList', 
            'APIImportPurchaseReturns'
        ].forEach(x => {
            (<any>SalesReturnMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
